import { useParams } from "react-router-dom";
import { Alert, EmptyState, ErrorState, InlineLoading, Page, Text } from "@marekl/adminer/components";
import { ApiError } from "../../../lib/api";
import { AppTopbar } from "../../../shell/AppTopbar";
import { CustomPageContent } from "../../../components/CustomPageContent";
import { useCustomPage } from "../../../lib/queries/customPages";

/** A stránka, as its reader sees it (`/stranky/:slug`). */
export function CustomPageView() {
  const { slug } = useParams<{ slug: string }>();
  const { data: page, isLoading, error, refetch } = useCustomPage(slug);
  const missing = error instanceof ApiError && error.status === 404;

  return (
    <>
      <AppTopbar crumbs={[{ label: page?.title ?? "Stránka" }]} />
      <Page>
        {page && <Page.Header title={page.title} />}
        <Page.Content stack gap="lg">
          {isLoading && <InlineLoading>Načítám stránku…</InlineLoading>}
          {missing && (
            <EmptyState
              title="Stránka nenalezena"
              description="Tato stránka neexistuje, nebo pro vás není určená."
            />
          )}
          {error && !missing && <ErrorState error={error} onRetry={refetch} />}
          {page && !page.published && (
            <Alert variant="warn">
              Stránka není zveřejněná. Vidíte ji jen jako správce stránek.
            </Alert>
          )}
          {page && <CustomPageContent body={page.body} />}
          {page?.audit_views && (
            <Text variant="muted">Otevření této stránky se zaznamenává do audit logu.</Text>
          )}
        </Page.Content>
      </Page>
    </>
  );
}
